import Image from '@/models/image';

export default class TransactionStaff {
  public avatar: Image = new Image();
  public firstName: string;
  public id: string;
  public lastName: string;
  public position: string;

  constructor(user: any) {
    if (user.avatar) {
      this.avatar = new Image(user.avatar);
    }

    this.firstName = user.firstName;
    this.id = user.id;
    this.lastName = user.lastName;
    this.position = user.position;
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
}
